const myWorker = new Worker("workers/uptWorker.js");

export async function useUptWorker(functionName, args) {
  const promise = new Promise((resolve, reject) => {
    myWorker.onmessage = function(e) {
      const res = e.data;
      resolve(res);
    };
    myWorker.onerror = function(e) {
      const res = e.data;
      console.log(e);
      reject(res);
    };
  });
  myWorker.postMessage([functionName, ...args]);
  const result = await promise;
  if (result.error) {
    throw result.error;
  }
  return result;
}
